import styled from 'styled-components';

import { colors } from '../../styles/tokens';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    margin-left: 5px;
    font-size: 14px;
    color: ${colors.onSurfaceVariant};
  }
`;
